import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject } from '@mri/types';

@Pipe({
  name: 'findOfArray',
  standalone: true
})
export class FindOfArrayPipe implements PipeTransform {

  transform<T = AnyObject>(list: Array<T>, findObject: Record<string, AnyObject>): T | undefined {
    if(!Array.isArray(list)) return undefined;

    return list.find(item => {
      let findReturn = true;

      for (const key in findObject) {
        if (findObject[key] != (item as AnyObject)[key]) {
          findReturn = false;

          break;
        }
      }

      return findReturn;
    });
  }

}
